module.exports = __webpack_public_path__ + "static/img/ph3a-logo.f269e1dc.png";